import React, { useState } from 'react';
import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import { ImagePlaceholder } from '../../../../../styles/LearnTab/slideBase.styles';

export const SlideImageLightboxModal = ({ image, onClose }) => {
  if (!image) return null;

  return (
    <Modal
      open={Boolean(image)}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          maxWidth: '90vw',
          maxHeight: '90vh',
          outline: 'none',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: -44,
            right: -44,
            color: '#fff',
            backgroundColor: 'rgba(0,0,0,0.4)',
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
          }}
        >
          <CloseIcon />
        </IconButton>
        <img
          src={image}
          alt="Enlarged slide"
          style={{
            display: 'block',
            maxWidth: '90vw',
            maxHeight: '90vh',
            objectFit: 'contain',
            borderRadius: '8px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          }}
        />
      </Box>
    </Modal>
  );
};

export const SlideImageLightbox = ({
  src,
  alt = 'Slide image',
  className,
  style,
  imageStyle,
  placeholder = false,
  onClick,
  onImageClick,
  ...props
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!src) return null;

  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (onImageClick) {
      onImageClick(src);
    } else {
      setIsModalOpen(true);
    }
  };

  const defaultImageStyle = {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: '4px',
    cursor: 'pointer',
    WebkitUserDrag: 'none',
  };

  const imgElement = (
    <img
      src={src}
      alt={alt}
      onClick={handleClick}
      className={className}
      style={{
        ...defaultImageStyle,
        ...imageStyle,
      }}
      {...props}
    />
  );

  return (
    <>
      {placeholder ? (
        <ImagePlaceholder style={style}>{imgElement}</ImagePlaceholder>
      ) : style ? (
        <Box style={style}>{imgElement}</Box>
      ) : (
        imgElement
      )}

      {!onImageClick && (
        <SlideImageLightboxModal
          image={isModalOpen ? src : null}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default SlideImageLightbox;
